import { useCountUp } from "@/hooks/useCountUp";
import { useScrollReveal } from "@/hooks/useScrollReveal";

interface AnimatedCounterProps {
  end: number;
  suffix?: string;
  prefix?: string;
  duration?: number;
}

export function AnimatedCounter({ end, suffix = "", prefix = "", duration = 2000 }: AnimatedCounterProps) {
  const { ref, isVisible } = useScrollReveal<HTMLSpanElement>({ threshold: 0.5 });
  const count = useCountUp({ end, duration, enabled: isVisible });
  
  const finalText = `${prefix}${end.toLocaleString()}${suffix}`;
  const minWidth = Math.max(8, finalText.length);

  return (
    <span ref={ref} className="font-bold inline-block tabular-nums" style={{ minWidth: `${minWidth}ch` }}>
      {prefix}{count.toLocaleString()}{suffix}
    </span>
  );
}
